import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=9866f40e&scoped=true"
import script from "./UpdateNotification.vue?vue&type=script&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=9866f40e&prod&lang=scss&scoped=true"
import style1 from "./UpdateNotification.vue?vue&type=style&index=1&id=9866f40e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9866f40e",
  null
  
)

export default component.exports